import React from "react";
import "./_select.scss";
import Select from "react-select";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";

const MultiSelect = ({
  maxwidth,
  onChange,
  options,
  value,
  className,
  placeholder,
  id,
  marginBottom,
  error,
  label,
  name,
  width,
  marginTop,
  isDisabled,
  maxMenuHeight,
  heigth,
  borderRadius,
}) => {
  const colourStyles = {
    menuList: (base) => ({
      ...base,
      maxHeight: maxMenuHeight ? maxMenuHeight : "12.5rem",
    }),
    control: (styles, isFocused) => ({
      ...styles,
      paddingLeft: "0.375rem",
      backgroundColor: "white",
      boxSizing: "border-box !important",
      minHeight: heigth ? `${heigth}` : "2rem",
      borderRadius: borderRadius ? `${borderRadius} !important` : "0.438rem",
      color: isFocused ? "#34aadc" : "black",
      borderColor: "unset !important",
      boxShadow: "unset !important",

      ":hover": {
        boxShadow: "unset !important",
        borderColor: "unset !important",
        border: "2px solid #34aadc !important",
      },
      border: "1px solid #ebebeb !important",
      "& input": {
        fontWeight: "400",
        fontSize: "0.625rem",
      },
      fontWeight: "600",
      fontSize: "0.87rem",
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        borderColor: "unset !important",
        backgroundColor: isSelected ? "#2ba7df" : isFocused ? "#e6f3f8" : "white",
        color: isSelected ? "white" : "black",
        ":active": {
          ...styles[":active"],
          backgroundColor: "#2ba7df",
          color: "white",
        },
      };
    },
    multiValue: (styles) => {
      return {
        ...styles,
        backgroundColor: "#e6f3f8",
        borderRadius: "4px",
      };
    },
    multiValueLabel: (styles) => {
      return {
        ...styles,
        color: "#2ba7df",
        fontWeight: "500",
      };
    },
    multiValueRemove: (styles) => {
      return {
        ...styles,
        color: "#2ba7df",
        ":hover": {
          backgroundColor: "#2ba7df",
          color: "white",
        },
      };
    },
  };

  const defaultValue = (options, value) => {
    if (!value || !Array.isArray(value)) return [];
    return value.map(v => options.find(option => option.value === v));
  };

  return (
    <div className={className}>
      {label && <label htmlFor={name}>{label}</label>}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          maxWidth: maxwidth,
          width: width,
          marginBottom: marginBottom,
          marginTop: marginTop,
        }}
      >
        <Select
          id={id}
          placeholder={placeholder}
          value={defaultValue(options, value)}
          onChange={(selectedOptions) => {
            const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : [];
            onChange(selectedValues);
          }}
          options={options}
          styles={colourStyles}
          isDisabled={isDisabled}
          isMulti={true}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          blurInputOnSelect={false}
        />

        {error ? (
          <p className="error">
            <ReportProblemIcon /> {error}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default MultiSelect; 